import React, {useState} from "react";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {Tooltip} from "@mui/material";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

export function InteractionPreview({interactionPreviewLink}) {
    const [previewOn, setPreviewOn] = useState(false);
    return <>
        <ConditionalComponent if={!!interactionPreviewLink}>
            <Tooltip
                placement='left'
                arrow
                title={
                    <video autoPlay loop style={{width: '100%'}}>
                        <source src={previewOn ? interactionPreviewLink : ''} type="video/webm"/>
                    </video>
                }
                onMouseEnter={() => setPreviewOn(true)}
                className='preview-interaction-button'
            >
                <PlayArrowIcon/>
            </Tooltip>
        </ConditionalComponent>
    </>;
}
